/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react'
import Grid from '@material-ui/core/Grid'
import { CustomField } from './CustomField'
import {
  IOneplaceLibraryContextProp,
  withOneplaceLibraryContext
} from '../OneplaceLibraryProvider'
import { ICustomField, IHelpInfo } from '../../models/CustomFields'

export interface ICustomFieldsGroupProps extends IOneplaceLibraryContextProp {
  label: string
  fields: ICustomField[]
  helpInfos: IHelpInfo[]
  onFieldChanged(field: ICustomField): void
}

export const CustomFieldsGroup = withOneplaceLibraryContext(
  (props: ICustomFieldsGroupProps) => {
    const fields = props.fields

    if (fields.length == 0) {
      return null
    }
    return (
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        {fields.map((field) => (
          <CustomField
            key={field.customFieldId}
            field={field}
            helpInfos={props.helpInfos}
            onFieldChanged={props.onFieldChanged}
          />
        ))}
      </Grid>
    )
  }
)
